import React from 'react';

import { JobPostingVisibleJobFragment } from '@/graphql/generated';

import { Metadata, StructuredData } from './components';

export type Props = {
  job: JobPostingVisibleJobFragment;
};

export const JobMetadata: React.FC<Props> = ({ job }) => (
  <>
    <Metadata job={job} />
    <StructuredData job={job} />
  </>
);
